module.exports = __webpack_public_path__ + "img/horizontal_4_6_8011.a5532c3a.png";